/* SWX Save Cart – Pill Buttons, transparent, #393939 text, 2px #3d3d3d borders, robust mount */
(function () {
  // === Konfiguration ===
  const COLOR_TEXT   = '#393939';   // Schriftfarbe Buttons + Hinweis
  const COLOR_BORDER = '#3d3d3d';   // Randfarbe (2px) für alle drei Elemente
  const COLOR_ARROW  = '#36ff00';   // Pfeilfarbe (auffälliges Grün)
  const BORDER_PX    = 2;           // Randstärke in Pixel

  const STYLE = `
    .swx-save-cart-wrap{
      margin-top:12px; display:flex; gap:8px; align-items:center; flex-wrap:wrap
    }
    .swx-save-cart-wrap .swx-save-btn,
    .swx-save-cart-wrap .swx-mail-btn{
      display:inline-flex; align-items:center; justify-content:center;
      padding:8px 12px;
      border:${BORDER_PX}px solid ${COLOR_BORDER}; border-radius:10000px;
      font-weight:600; cursor:pointer; background:transparent;
      font-size:.85rem; line-height:1.1; flex:0 0 calc(50% - 4px);
      white-space:nowrap; min-height:39px; color:${COLOR_TEXT}
    }
    .swx-save-cart-wrap .swx-ico{ margin-right:6px; font-size:1rem; line-height:1 }

    .swx-save-cart-wrap .swx-note{
      flex-basis:100%; display:inline-flex; justify-content:center; align-items:center;
      margin-top:8px; font-size:calc(.86rem + 1px); font-weight:700; color:${COLOR_TEXT};
      background:transparent; padding:6px 12px; border-radius:10000px;
      border:${BORDER_PX}px solid ${COLOR_BORDER};
      width:max-content; max-width:100%; margin-left:auto; margin-right:auto;
      pointer-events:none; user-select:none;
    }
    .swx-save-cart-wrap .swx-note .swx-arrow{
      color:${COLOR_ARROW}; margin:0 6px; font-weight:800
    }

    .swx-toast{
      position:fixed; left:50%; transform:translateX(-50%);
      bottom:18px; padding:10px 14px; border-radius:12px;
      background:rgba(0,0,0,.85); color:#fff; font-weight:600; z-index:9999
    }
    .swx-copy-modal{
      position:fixed; inset:auto 12px 18px 12px; background:rgba(0,0,0,.9);
      color:#fff; padding:12px; border-radius:12px; z-index:10000
    }
    .swx-copy-modal p{ margin:0 0 8px 0; font-weight:600 }
    .swx-copy-modal input{
      width:100%; padding:8px 10px; border-radius:10px; border:none; font-size:.9rem
    }
    .swx-copy-modal button{
      margin-top:8px; padding:6px 10px; border-radius:10px; border:1px solid #fff;
      background:transparent; color:#fff; font-weight:600
    }
  `;

  function injectStyle(){
    if(document.getElementById('swx-save-style')) return;
    const s=document.createElement('style');
    s.id='swx-save-style'; s.textContent=STYLE; document.head.appendChild(s);
  }

  async function getCart(){
    const r=await fetch('/cart.js',{credentials:'same-origin'});
    if(!r.ok) throw new Error('Cart fetch failed');
    return r.json();
  }

  function buildCartUrl(items){
    const parts = items.filter(i=>i.quantity>0).map(i=>i.variant_id+':'+i.quantity);
    return location.origin + '/cart/' + parts.join(',') + '?saved=1';
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  async function copyNative(text){
    if(navigator.clipboard && window.isSecureContext){
      try{ await navigator.clipboard.writeText(text); return true; }catch(e){}
    }
    return false;
  }

  function copyExecCommand(text){
    try{
      const el=document.createElement('input');
      el.value=text; el.setAttribute('readonly','');
      el.style.position='fixed'; el.style.opacity='0'; el.style.zIndex='-1';
      document.body.appendChild(el);
      el.focus(); el.select();
      let ok=false; try{ ok=document.execCommand('copy'); }catch(e){}
      document.body.removeChild(el);
      return ok;
    }catch(e){ return false; }
  }

  function showManualCopy(text){
    const box=document.createElement('div');
    box.className='swx-copy-modal';
    box.innerHTML='<p>Link zum Warenkorb</p><input type="text" readonly /><button type="button">Schließen</button>';
    document.body.appendChild(box);
    const input=box.querySelector('input'); input.value=text; input.focus(); input.select();
    box.querySelector('button').onclick=()=>box.remove();
  }

  function toast(msg){
    const t=document.createElement('div');
    t.className='swx-toast'; t.textContent=msg;
    document.body.appendChild(t);
    setTimeout(()=>t.remove(),1800);
  }

  async function handleCopy(){
    try{
      const cart=await getCart();
      if(!cart.items || !cart.items.length){ toast('Warenkorb ist leer'); return; }
      const url=buildCartUrl(cart.items);

      if(isIOS && navigator.share){
        try{ await navigator.share({ title:'Warenkorb', text:'Gespeicherter Warenkorb', url }); toast('Link geteilt'); return; }
        catch(e){}
      }
      if(await copyNative(url)){ toast('Link kopiert'); return; }
      if(copyExecCommand(url)){ toast('Link kopiert'); return; }
      showManualCopy(url); toast('Kopieren manuell auswählen');
    }catch(e){
      console.error('SWX copy error', e);
      toast('Bitte E Mail senden nutzen');
    }
  }

  async function handleMail(){
    try{
      const cart=await getCart();
      if(!cart.items || !cart.items.length){ toast('Warenkorb ist leer'); return; }
      const url=buildCartUrl(cart.items);
      const subject=encodeURIComponent('Mein gespeicherter Warenkorb');
      const body=encodeURIComponent('Hier ist mein Warenkorb.\n\n' + url);
      location.href='mailto:?subject=' + subject + '&body=' + body;
    }catch(e){
      console.error('SWX mail error', e);
      toast('E Mail konnte nicht geöffnet werden');
    }
  }

  function makeUi(){
    const wrap=document.createElement('div');
    wrap.className='swx-save-cart-wrap';
    wrap.innerHTML =
      '<button type="button" class="swx-save-btn"><span class="swx-ico">🔗</span><span>Link speichern</span></button>' +
      '<button type="button" class="swx-mail-btn"><span class="swx-ico">✉️</span><span>E-Mail senden</span></button>' +
      '<span class="swx-note"><span class="swx-arrow">↑ </span> Warenkorb speichern? <span class="swx-arrow"> ↑</span></span>';
    wrap.querySelector('.swx-save-btn').onclick=handleCopy;
    wrap.querySelector('.swx-mail-btn').onclick=handleMail;
    return wrap;
  }

  // Robustes Einhängen (optional bevorzugter Mount: #swx-save-cart-mount)
  function mountInto(target){
    if(!target) return;
    if(target.querySelector('.swx-save-cart-wrap')) return;
    target.appendChild(makeUi());
  }

  function inject(){
    const explicit = document.getElementById('swx-save-cart-mount');
    if(explicit){ mountInto(explicit); return; }

    const btnSelectors = [
      'button[name="checkout"]','[name="checkout"]',
      'form[action="/cart"] button[type="submit"]',
      '.cart__ctas button[type="submit"]','.cart__checkout-button','.totals__checkout'
    ];
    for(const sel of btnSelectors){
      const btn = document.querySelector(sel);
      if(btn){
        if(btn.parentElement && !btn.parentElement.querySelector('.swx-save-cart-wrap')){
          btn.insertAdjacentElement('afterend', makeUi());
        }
        return;
      }
    }

    const formSelectors = ['form[action="/cart"]','cart-items form','.cart__ctas','.drawer__inner form','cart-drawer form'];
    for(const sel of formSelectors){
      const form = document.querySelector(sel);
      if(form){ mountInto(form); return; }
    }
  }

  function init(){
    injectStyle();
    inject();
    const mo=new MutationObserver(()=>inject());
    mo.observe(document.documentElement,{childList:true,subtree:true});
    document.addEventListener('cart:updated', inject);
    document.addEventListener('cart:refresh', inject);
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
